import "../../../../../../common/aws-sdk-2.235.1.min.js";
import gptImg from '../gptImg.vue'

const minxin = {
  components: {
    gptImg,
  },
  data() {
    return {
      options2: {
        word: "单词/词组",
        sentence: "句子/短文",
        QA: "题目",
        createRole: "创建角色",
        theme: "新建主题"
      },
      progress: 0,
      isFinishSize: 0,
      proVisible: false,
      isAllSize: 0,
      imgUrl: "",
      sysPicVisible:false
    };
  },
  directives: {
    autoHeight: {
      update(el, binding) {
        const { value } = binding;
        if (value && typeof value === "number") {
          el.style.height = `${value}px`;
        } else {
          el.style.height = "auto";
        }
      },
      componentUpdated(el) {
        el.style.height = `${el.scrollHeight + 5}px`;
      }
    }
  },
  computed: {},
  mounted() {},
  activated() {},
  methods: {
    getImg(){
      this.sysPicVisible = true
    },
    depthCopy(s) {
      return s ? JSON.parse(JSON.stringify(s)) : "";
    },
    addImg(e) {
        var el = e.currentTarget;
        el.getElementsByTagName("input")[0].click();
        e.target.value = "";
    },
    beforeUpload(event, type) {
      // const loading = this.openLoading();
      var file = event.target.files[0];
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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"
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      var imgA = [
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif",
        "webp",
        "psd",
        "svg",
        "tiff"
      ];
      if(imgA.indexOf(file.name.split(".")[file.name.split(".").length - 1]) == -1){
        this.$message.error("请上传图片格式文件");
        return
      }
      _this.progress = 0;
      _this.proVisible = true;
      _this.isFinishSize = 0;
      _this.isAllSize = (file.size / 1024 / 1024).toFixed(2);
      _this.$forceUpdate();
      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read"
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function(evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
            _this.progress = parseInt((evt.loaded / evt.total) * 100);
            _this.isFinishSize = (evt.loaded / 1024 / 1024).toFixed(2);
            _this.$forceUpdate();
          })
          .send(function(err, data) {
            _this.progress = 100;
            _this.isFinishSize = _this.isAllSize;
            _this.$forceUpdate();
            setTimeout(() => {
              _this.proVisible = false;
              _this.$forceUpdate();
            }, 1000);
            // loading.close();
            if (err) {
              _this.$message.error("上传失败");
            } else {
              _this.imgUrl = data.Location;
              console.log(data.Location);
            }
          });
      }
    },
    checkImg(img){
      this.$hevueImgPreview(img);
    },
    deleteImg(){
      this.$confirm('确认删除该图片吗?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.checkJson.img = ''
          this.$emit('setJson',this.checkJson)
        })
        .catch(() => { });
    },
  }
};

export default minxin;



// WEBPACK FOOTER //
// ./src/components/pages/EnglishVoice/component/component/minxins/minxin.js